export default "__VITE_ASSET__m4jxS5$z__"